import React from 'react'

import { LINK_MAP } from 'constants/travelsafe'

import { ReactComponent as Document } from 'assets/icons/doclink.svg';
import { ReactComponent as Download } from 'assets/icons/download.svg';

function LinkIconMap({ type, ...props }) {
	switch (type) {
		case LINK_MAP.LINK:
			return <Document {...props} />
        case LINK_MAP.DOWNLOAD:
            return <Download {...props}/>
		default:
			return <Document {...props} />
	}
}

export default LinkIconMap;
